import { environment } from '../../environments/environment'
import { QueryString } from './query-string'

export interface CardDeviceType {
  device_type?: string
  downloadUrl(): string
  componentUrl(): string
}

export class CardIdParams implements CardDeviceType {
  public constructor(public id: string, public device_type?: string) { }

  public get path(): string {
    let path = `download/${this.id}`
    if (this.device_type) {
      path = path + `?device_type=${this.device_type}`
    }
    return path
  }

  public componentUrl(): string {
    return window.location.origin + '/' + this.path
  }

  public downloadUrl(): string {
    return environment.apiUrl + 'cards/' + this.path
  }
}

export class CardPersonaOrgParams implements CardDeviceType {
  public device_type?: string
  public persona_id: string | number
  public boss_organization_id: string | number

  public constructor(params: any) {
    this.device_type = params.device_type
    this.persona_id  = params.persona_id
    this.boss_organization_id = params.boss_organization_id
  }

  public get query(): string {
    const query: any = { persona_id: this.persona_id, boss_organization_id: this.boss_organization_id}
    if (this.device_type) {
      query.device_type = this.device_type
    }
    return QueryString.build(query)
  }

  public componentUrl(): string {
    return window.location.origin + '/download?' + this.query
  }

  public downloadUrl(): string {
    return environment.apiUrl + 'cards/download?' + this.query
  }
}

export type DownloadParams = CardIdParams | CardPersonaOrgParams

export class CardDownload {
  public constructor(private params: DownloadParams) { }

  public download() {
    window.location.href = this.downloadUrl()
  }

  public componentUrl(): string {
    return this.params.componentUrl()
  }

  public downloadUrl(): string {
    return this.params.downloadUrl()
  }
}
